import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ContractContext } from '../contexts/ContractContext';

const ProtectedRoute = ({
    component: Component, // Pass component to be rendered dependent on isValidRoute prop returns true
    isValidRoute, // Condition to be set by user on condition whether to allow render or not
    isCallBack = false, // Used for routing of callbacks, where being returned for third party services. Ensures routing without issues, due to unset contexts
    ...rest // Any other props passed to be added to component to be rendered
}) => {
    const {
        data: { clientId }
    } = useContext(ContractContext);
    const isApple = clientId?.toLowerCase() === 'apple';
    /* 
    TO BE USED FOR ROUTES THAT WE MAY NOT WANT RENDERED IN ALL CASES, WITH THIS COMPONENT 
    WE CAN SELECTIVELY RENDER BASED ON isValidRoute PROP, ANY CONDITION CAN BE SET IN APP.JS COMPONENT
  */
    return (
        <Route
            {...rest}
            render={(props) =>
                isValidRoute || isCallBack ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: isApple ? '/' : '/plansearch'
                        }}
                    />
                )
            }
        />
    );
};

export default ProtectedRoute;
